import type {SVGProps} from 'react'
const SvgCarrotLarge = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path stroke="#AFB7C2" d="m8 3 9 9-9 9" />
  </svg>
)
export default SvgCarrotLarge
